import { snapfishActionTypes } from './snapfish-action-types';
import { authorizedRequest } from '../../common/request';

export const requestSnapfishCollections = (dispatch, offset = 0, amIfetchingAlbums = false,  max = 25) => {
	if(amIfetchingAlbums){
		return{
			type: snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_WAIT
		};
	}
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/snapfish/ccs?offset=${offset}&max=${max}&format=deep`;

	authorizedRequest(uri)
		.then(data => dispatch(snapfishCollectionsSuccess(data)))
		.catch(error => dispatch(snapfishCollectionsFailure(error)));

	return {
		type: snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_REQUEST
	};
};

export const requestSnapfishPhotoElements = (dispatch, ccId, offset, max, amIfetchingItems = false) => {
	if(amIfetchingItems){
		return{
			type: snapfishActionTypes.SNAPFISH_PHOTO_ELEMENTS_WAIT
		};
	}
	const uri = `${process.env
		.REACT_APP_WEB_API_URI}/sec/v1/snapfish/ccs/${ccId}/cces?offset=${offset}&max=${max}&format=deep`;
	authorizedRequest(uri)
		.then(data => dispatch(snapfishPhotoElementsSuccess(data)))
		.catch(error => dispatch(snapfishPhotoElementsFailure(error)));

	return {
		type: snapfishActionTypes.SNAPFISH_PHOTO_ELEMENTS_REQUEST
	};
};

export const requestSnapfishSelectedPhotos = (dispatch, uuid) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/snapfish/selection/${uuid}`;

	authorizedRequest(uri)
		.then(data => dispatch(snapfishSelectedPhotosSuccess(data)))
		.catch(error => dispatch(snapfishSelectedPhotosFailure(error)));

	return {
		type: snapfishActionTypes.SNAPFISH_RETRIEVE_SELECTED_PHOTOS_REQUEST
	};
};

//TODO: Support more than just CCEs being selected, e.g. SPs from the Timeline
export const requestSnapfishSaveSelection = (dispatch, selectionIds) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/selection`;

	authorizedRequest(uri, { 'imemops.CustomCollectionElement': selectionIds }, 'POST')
		.then(uuid => dispatch(snapfishSaveSelectionSuccess(uuid)))
		.catch(error => dispatch(snapfishSaveSelectionFailure(error)));

	return {
		type: snapfishActionTypes.SNAPFISH_SAVE_SELECTION_REQUEST
	};
};

//TODO: Support more than just CCEs being selected, e.g. SPs from the Timeline
export const requestSnapfishSaveSelectionSinglePictureWithRedirect = (dispatch, selectionIds, product) => {
	const uri = `${process.env.REACT_APP_WEB_API_URI}/sec/v1/selection`;

	authorizedRequest(uri, { 'imemops.CustomCollectionElement': selectionIds }, 'POST')
		.then(uuid => dispatch(snapfishSaveSelectionSinglePictureRedirectSuccess(uuid, product)))
		.catch(error => dispatch(snapfishSaveSelectionFailure(error)));

	return {
		type: snapfishActionTypes.SNAPFISH_SAVE_SELECTION_REQUEST
	};
};

const snapfishSaveSelectionSinglePictureRedirectSuccess = (uuid, product) => {
	window.location = `${process.env.REACT_APP_SHOP_URI}/gifts/ssoentrypoint?isLoggedIn=true&selection=`+uuid.uuid+`&product=`+product;
	return {
		type: snapfishActionTypes.SNAPFISH_SAVE_SELECTION_SUCCESS,
		uuid: uuid
	};
};

export const sendSelectionToSnapfish = (successMethod, selectedPhotoElements) => {
    successMethod(selectedPhotoElements);

    return {
        type: snapfishActionTypes.SNAPFISH_SEND_SUCCESS
    };
};

export const sendErrorToSnapFish = (failureMethod, resultObject) => {
    failureMethod(resultObject);

    return {
        type: snapfishActionTypes.SNAPFISH_SEND_FAILURE
    };
};

export const selectItem = id => {
	return {
		type: snapfishActionTypes.SNAPFISH_SELECT_ITEM,
		id: id
	};
};

export const deselectItem = id => {
	return {
		type: snapfishActionTypes.SNAPFISH_DESELECT_ITEM,
		id: id
	};
};

export const clearSelection = () => {
    return {
        type: snapfishActionTypes.SNAPFISH_CLEAR_SELECTED_PHOTOS
    };
};

export const clearPhotoElements = () => {
	return {
		type: snapfishActionTypes.SNAPFISH_CLEAR_PHOTO_ELEMENTS
	};
};

export const setCurrentAlbumId = id => {
	return {
		type: snapfishActionTypes.SNAPFISH_SET_CURRENT_ALBUM_ID,
		id: id
	};
};

export const setAlbumViewMode = () => {
	return {
		type: snapfishActionTypes.SNAPFISH_SET_ALBUM_VIEW_MODE
	};
};

export const setUploadViewMode = () => {
	return {
		type: snapfishActionTypes.SNAPFISH_SET_UPLOAD_VIEW_MODE
	};
};

const snapfishCollectionsSuccess = data => {

	const albums = data.ccs;
	const count = data.count;
	const isCompleteAlbums = data.offset + albums.length === count;

	return {
		type: snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_SUCCESS,
		data: data,
		offset: data.offset,
		count: data.count,
		collections: data.ccs,
		max: data.max,
		isCompleteAlbums
	};
};

const snapfishCollectionsFailure = error => {
	return {
		type: snapfishActionTypes.SNAPFISH_CUSTOM_COLLECTION_FAILURE,
		error: error
	};
};

const snapfishPhotoElementsSuccess = data => {
	const items = data.cces;
	const count = data.count;
	const isCompleteItems = data.offset + items.length === count;
	return {
		type: snapfishActionTypes.SNAPFISH_PHOTO_ELEMENTS_SUCCESS,
		data: data,
		elements: data.cces,
		count: data.count,
		offset: data.offset,
		max: data.max,
		ccId: data.ccId,
		isCompleteItems,
	};
};

const snapfishPhotoElementsFailure = error => {
	return {
		type: snapfishActionTypes.SNAPFISH_RETRIEVE_SELECTED_PHOTOS_FAILURE,
		error: error
	};
};

const snapfishSelectedPhotosSuccess = data => {
	return {
		type: snapfishActionTypes.SNAPFISH_RETRIEVE_SELECTED_PHOTOS_SUCCESS,
		data: data
	};
};

const snapfishSelectedPhotosFailure = error => {
	return {
		type: snapfishActionTypes.SNAPFISH_RETRIEVE_SELECTED_PHOTOS_FAILURE,
		error: error
	};
};

const snapfishSaveSelectionSuccess = uuid => {
	return {
		type: snapfishActionTypes.SNAPFISH_SAVE_SELECTION_SUCCESS,
		uuid: uuid
	};
};

const snapfishSaveSelectionFailure = error => {
	return {
		type: snapfishActionTypes.SNAPFISH_SAVE_SELECTION_FAILURE,
		error: error
	};
};



// WEBPACK FOOTER //
// ./src/snapfish/actions/snapfish-actions.js